<template>
  <div class="form-detail">
    <h1>{{ title }}</h1>
    <div class="card-body">
      <!-- Nếu type là table -->
      <template v-if="type === 'table'">
        <div class="table-responsive">
          <table class="table table-hover table-bordered mb-0">
            <thead class="thead-light">
              <tr>
                <th
                  v-for="(header, i) in headers"
                  :key="i"
                  :class="header.thClass"
                  :style="header.thStyle"
                >
                  {{ header.text }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="!fields.length">
                <td :colspan="headers.length" class="text-center text-muted">Không có dữ liệu</td>
              </tr>
              <tr v-for="(row, rowIndex) in fields" :key="rowIndex">
                <td v-for="(header, colIndex) in headers" :key="colIndex" :class="header.class">
                  <!-- Có thể customer cho từng cột -->
                  <slot :name="header.key" :value="row[header.key]" :row="row" :header="header">
                    <!-- Dữ liệu đổ ra UI mặc định -->
                    {{ row[header.key] }}
                  </slot>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </template>

      <template v-else-if="type === 'images'">
        <div class="img-list">
          <ul v-viewer>
            <li v-for="(itemImg, index) in fields" :key="index">
              <a href="#popup-slider" data-toggle="modal">
                <img :src="itemImg" alt="" />
              </a>
            </li>
          </ul>
        </div>
      </template>

      <!-- Nếu type khác table (form) -->
      <template v-else>
        <slot name="form" :fields="fields"></slot>
        <template v-if="!$slots.form && fields && fields.length">
          <div class="form-group form-row" v-for="(item, index) in fields" :key="index">
            <label class="col-sm-4 col-form-label">
              {{ item.label }}<span class="float-right">:</span>
            </label>
            <div class="col-sm-8">
              <slot :name="item.key" :value="item.value" :item="item">
                <p class="form-control-plaintext f12">{{ item.value ?? '' }}</p>
              </slot>
            </div>
          </div>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'CardDetail',
    props: {
      title: {
        type: String,
        default: 'Thông tin chi tiết',
      },
      fields: {
        type: Array,
        default: () => [],
      },
      type: {
        type: String,
        default: 'form',
      },
      headers: {
        type: Array,
        default: () => [],
      },
    },
  }
</script>

<style scoped>
  .form-detail {
    margin-bottom: 20px;
  }
  .f12 {
    font-size: 12px;
  }
  .text-right {
    text-align: right;
  }
</style>
